declare namespace $ {

	type $mol_view__sub_shm_hitalama_table_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_table['head'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_list__sub_shm_hitalama_table_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_table['rows'] >
		,
		ReturnType< $mol_list['sub'] >
	>
	export class $shm_hitalama_table extends $mol_view {
		head( ): readonly(any)[]
		Head( ): $mol_view
		rows( ): readonly(any)[]
		Body( ): $mol_list
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map